import React, { useState } from 'react'
import { Tabs, Card, Row, Col, Button, Typography } from 'antd'
import { SyncOutlined, BarChartOutlined, ToolOutlined, ReconciliationOutlined } from '@ant-design/icons'
import { Guard } from '../../features/session/guard'
import { RecalcModal } from './RecalcModal'
import { RecalcSummaryModal } from './RecalcSummaryModal'
import { Diagnostics } from './Diagnostics'
import { RdcCheck } from './RdcCheck'

const { Text } = Typography

const CommandsTab: React.FC = () => {
  const [isRecalcModalOpen, setIsRecalcModalOpen] = useState(false)
  const [recalcSummaryType, setRecalcSummaryType] = useState<'active' | 'passive' | null>(null)

  const commandGroups = [
    {
      groupTitle: 'Financial System',
      commands: [
        {
          title: 'Recalculate',
          description: 'Пересчитать баланс по определенному кошельку за период.',
          notes: 'Внимание: указание ранее несуществующей валюты добавит её в кошелек',
          icon: <SyncOutlined />,
          onClick: () => setIsRecalcModalOpen(true),
        },
        {
          title: 'Пересчитать активы',
          description: 'Пересчитать обороты за указанный период.',
          notes: null,
          icon: <SyncOutlined />,
          onClick: () => setRecalcSummaryType('active'),
        },
        {
          title: 'Пересчитать пассивы',
          description: 'Пересчитать обороты за указанный период.',
          notes: null,
          icon: <SyncOutlined />,
          onClick: () => setRecalcSummaryType('passive'),
        },
      ],
    },
  ]

  return (
    <>
      {commandGroups.map((group, groupIdx) => (
        <Card title={group.groupTitle} key={groupIdx} style={{ marginBottom: 16 }}>
          <Row gutter={[16, 16]}>
            {group.commands.map((cmd, idx) => (
              <Col key={idx} xs={24} md={12} lg={8}>
                <Card size="small" hoverable>
                  <Typography.Title level={5} style={{ marginTop: 0 }}>
                    {cmd.title}
                  </Typography.Title>
                  <Text>{cmd.description}</Text>
                  {cmd.notes && (
                    <div style={{ marginTop: 8 }}>
                      <Text type="secondary" italic>{cmd.notes}</Text>
                    </div>
                  )}
                  <div style={{ marginTop: 12 }}>
                    <Button type="primary" icon={cmd.icon} onClick={cmd.onClick}>
                      Recalculate
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
      ))}

      <RecalcModal
        isOpen={isRecalcModalOpen}
        onClose={() => setIsRecalcModalOpen(false)}
      />
      <RecalcSummaryModal
        isOpen={recalcSummaryType !== null}
        onClose={() => setRecalcSummaryType(null)}
        type={recalcSummaryType ?? 'active'}
      />
    </>
  )
}

export const TechPage = () => {
  return (
    <Guard permission="tech_page_view">
      <div style={{ marginTop: 16 }}>
        <Tabs
          defaultActiveKey="diagnostics"
          items={[
            {
              key: 'diagnostics',
              label: (
                <span>
                  <BarChartOutlined />
                  Diagnostics
                </span>
              ),
              children: <Diagnostics />,
            },
            {
              key: 'commands',
              label: (
                <span>
                  <ToolOutlined />
                  Commands
                </span>
              ),
              children: <CommandsTab />,
            },
            {
              key: 'rdc-check',
              label: (
                <span>
                  <ReconciliationOutlined />
                  RDC Check
                </span>
              ),
              children: <RdcCheck />,
            },
          ]}
        />
      </div>
    </Guard>
  )
}
